module.exports = __webpack_public_path__ + "static/img/img03.e704ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img03.png
// module id = 4/Us
// module chunks = 46